function stringArrayToIntArray(stringArray) {
  return stringArray.map((x) => +x);
}

export default stringArrayToIntArray;
